import type { ReactNode } from 'react'
import { Badge } from '@/components/ui/badge'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet'
import type { AuditLog } from '@/api/audit'
import { AuditJsonViewer } from './AuditJsonViewer'

interface AuditLogDetailDrawerProps {
	log: AuditLog | null
	open: boolean
	onOpenChange: (open: boolean) => void
}

function Field({ label, value }: { label: string; value: ReactNode }) {
	return (
		<div className="space-y-1">
			<div className="text-xs text-muted-foreground">{label}</div>
			<div className="break-words text-sm">{value || '-'}</div>
		</div>
	)
}

export function AuditLogDetailDrawer({ log, open, onOpenChange }: AuditLogDetailDrawerProps) {
	return (
		<Sheet open={open} onOpenChange={onOpenChange}>
			<SheetContent className="w-full overflow-y-auto sm:max-w-2xl">
				<SheetHeader>
					<SheetTitle>操作日志详情</SheetTitle>
				</SheetHeader>
				{log && (
					<div className="mt-6 space-y-6">
						<div className="grid gap-4 sm:grid-cols-2">
							<Field label="操作时间" value={new Date(log.created_at).toLocaleString()} />
							<Field label="操作人" value={log.operator_nickname || log.operator_username || `用户 #${log.operator_id}`} />
							<Field label="模块" value={log.module} />
							<Field label="操作" value={log.action} />
							<Field label="资源" value={log.resource_no || log.resource_id} />
							<Field label="结果" value={<Badge variant={log.result === 'success' ? 'success' : 'destructive'}>{log.result === 'success' ? '成功' : '失败'}</Badge>} />
							<Field label="IP" value={log.ip} />
							<Field label="Request ID" value={log.request_id} />
						</div>
						<Field label="摘要" value={log.summary} />
						<Field label="User-Agent" value={log.user_agent} />
						{log.result === 'failed' && <Field label="错误信息" value={log.error_message} />}
						<div className="grid gap-4 lg:grid-cols-2">
							<div className="space-y-2">
								<h3 className="text-sm font-medium">操作前</h3>
								<AuditJsonViewer value={log.before_data} />
							</div>
							<div className="space-y-2">
								<h3 className="text-sm font-medium">操作后</h3>
								<AuditJsonViewer value={log.after_data} />
							</div>
						</div>
						<div className="space-y-2">
							<h3 className="text-sm font-medium">补充信息</h3>
							<AuditJsonViewer value={log.metadata} />
						</div>
					</div>
				)}
			</SheetContent>
		</Sheet>
	)
}
